// System
import { useMemo } from 'react';

// Reducers
import { setColumnVisibility } from '@Modal/reducers/aviatorRoles/roleTableSlice';

// Redux
import { useDispatch, useSelector } from 'react-redux';

// Types
import { StoreInterface } from 'src/app/types';

export const useAviatorRolesTable = () => {
  const dispatch = useDispatch();

  const { columnVisibility, columnVisibilityOptions, selectedFilters } = useSelector(
    (state: StoreInterface) => state?.aviatorRolesTable
  );

  const aviatorRolesListFilters = useMemo(() => {
    const columnVisibilityStrArr = Array.from(Object.values(columnVisibility)).map((filt) => filt);
    return columnVisibilityStrArr as string[];
  }, [columnVisibility]);

  const handleApplyColumnVisibility = (column: string[]) => {
    const newVisibleColumns = [...aviatorRolesListFilters, ...column];
    if (aviatorRolesListFilters.filter((col) => column.includes(col)).length > 0) {
      const filteredNewVisibleColumns = aviatorRolesListFilters.filter((col) => col !== column[0]);
      dispatch(setColumnVisibility(filteredNewVisibleColumns));
    } else {
      dispatch(setColumnVisibility(newVisibleColumns));
    }
  };

  const visiblityCustomizable = useMemo(
    () => ({
      value: columnVisibility,
      options: columnVisibilityOptions,
      apply: (value: string[]) => handleApplyColumnVisibility(value),
    }),
    [columnVisibility, columnVisibilityOptions]
  );

  return {
    // State
    selectedFilters,
    columnVisibility,
    aviatorRolesListFilters,
    visiblityCustomizable,
    columnVisibilityOptions,
    // Actions
    handleApplyColumnVisibility,
  };
};
